export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/lettering.de2a2a2.svg";